import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import EntityHeader from "./common/EntityHeader";
import FieldDisplay from "./common/FieldDisplay";
import {
  formatDate,
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";
import BedAppointmentModal from "./common/BedAppointmentModal";

function BedAppointmentsEntity({
  clientId,
  clientProgram,
  bedAppointments,
  updateBedAppointments,
  showExpired,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialData, setInitialData] = useState();
  const navigate = useNavigate();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const showModal = (bedAppointment) => {
    const obj = {
      ccx_bedappointmentid: bedAppointment.ccx_bedappointmentid,
      ccx_bed: getFieldText(bedAppointment.ccx_bed),
      bedName: getFieldName(bedAppointment.ccx_bed),
      ccx_serviceitem: getFieldText(bedAppointment.ccx_serviceitem),
      serviceItemName: getFieldName(bedAppointment.ccx_serviceitem),
      ccx_servicestatuslookup: getFieldText(
        bedAppointment.ccx_servicestatuslookup
      ),
      serviceStatusName: getFieldName(bedAppointment.ccx_servicestatuslookup),
      ccx_clientdiagnosis: getFieldText(bedAppointment.ccx_clientdiagnosis),
      diagnosisName: getFieldName(bedAppointment.ccx_clientdiagnosis),
      ccx_startdate: formatDate(getFieldDate(bedAppointment.ccx_startdate)),
      ccx_enddate: bedAppointment.ccx_enddate
        ? formatDate(getFieldDate(bedAppointment.ccx_enddate))
        : null,
    };

    setInitialData(obj);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const addNew = () => {
    setInitialData(undefined);
    setIsOpen(true);
  };

  //Route Access Protection
  useEffect(() => {
    if (safyInfo) {
      const modules = safyInfo.user.modules;
      if (
        modules.includes("My Caseload") === false &&
        modules.includes("Team Caseload") === false &&
        modules.includes("Foster Homes") === false
      ) {
        navigate("/");
      }
    } else navigate("/");
  });

  return (
    <>
      {isOpen ? (
        <BedAppointmentModal
          isOpen={isOpen}
          hideModal={hideModal}
          initialData={initialData}
          clientProgram={clientProgram}
          bedAppointments={bedAppointments}
          updateBedAppointments={updateBedAppointments}
        ></BedAppointmentModal>
      ) : null}
      <EntityHeader
        title={"Bed Appointments"}
        add={addNew}
        {...rest}
        body={bedAppointments.map((bedAppointment) => (
          <div
            className={
              bedAppointment.ccx_actualdischargedate !== undefined &&
              !showExpired
                ? "d-none p-2"
                : "d-block p-2"
            }
            key={bedAppointment.ccx_bedappointmentid}
          >
            <Card bg="dark" className="card-safy">
              <Card.Header
                className="p-0 ps-2 bg-safy1-1"
                style={{ color: "white" }}
              >
                <div className="row">
                  <div className="col-10 ps-4 pt-1">
                    {bedAppointment.ccx_name}
                  </div>
                  <div className="col-2">
                    <i
                      className="fas fa-pen float-end p-2"
                      onClick={() => {
                        showModal(bedAppointment);
                      }}
                    ></i>
                  </div>
                </div>
              </Card.Header>
              <Card.Body
                className={
                  bedAppointment.ccx_actualdischargedate === undefined
                    ? "p-2 card-body-safy"
                    : "p-2 bg-warning"
                }
              >
                <FieldDisplay
                  label="Service Item:"
                  value={getFieldName(bedAppointment.ccx_serviceitem)}
                />
                <FieldDisplay
                  label="Service Status:"
                  value={getFieldName(bedAppointment.ccx_servicestatuslookup)}
                />
                <FieldDisplay
                  label="Actual Admission:"
                  value={getFieldDate(bedAppointment.ccx_actualadmissiondate)}
                />
                {bedAppointment.ccx_actualdischargedate && (
                  <FieldDisplay
                    label="Actual Discharge: "
                    value={getFieldDate(bedAppointment.ccx_actualdischargedate)}
                  />
                )}
              </Card.Body>
            </Card>
          </div>
        ))}
      />
    </>
  );
}

export default BedAppointmentsEntity;
